import { FilterMatchMode } from 'primereact/api';

export interface Order {
  isAscending: boolean;
  orderColumn: string;
}

export interface Page {
  index: number;
  size: number;
}

export interface PaginationParams {
  order: Order;
  page: Page;
}

export interface PaginatorState {
  currentPage: number;
  totalPages: number;
  rows: number;
}

export interface DateFilters {
  startDate: string;
  endDate: string;
}

export class TagsFilters {
  tags: string[];
  noTag: boolean;
}

export interface SubTableOrder extends Order {}

export interface PaginatedResultOld<T> {
  data: T[];

  totalPageNumber: number;
}

export interface PaginatedResult<T> {
  data: T[];

  totalCount: number;
}

export enum SearchMode {
  STARTS_WITH = 'STARTS_WITH',
  CONTAINS = 'CONTAINS',
  EQUALS = 'EQUALS',
  IN = 'IN',
  BETWEEN = 'BETWEEN',
  OVERLAPS = 'OVERLAPS',
}

export interface TableFilter {
  value: any;

  actualValue?: any;

  searchMode: SearchMode;

  matchMode: FilterMatchMode;
}

export interface TableFilterData {
  [key: string]: TableFilter;
}
